<template>
  <div class="sidebar-container">
    <!-- هدر و اطلاعات کاربر -->
    <header class="custom-header">
      <div class="logo-container">
        <router-link to="/">
          <img
            src="/assets/media/logo behfamSITE.svg"
            alt="سامانه جامع و یکپارچه بهفام"
            class="logo-img"
          />
        </router-link>
      </div>
      <div class="header-actions">
        <div
          style="
            width: 95%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 2.3vw;
          "
        >
          <div class="action-icons">
                        <!-- آیکن تایمر (ساعت) -->
           
            <!-- آیکن خانه -->
            <router-link to="/" title="پیشخوان">
              <div
                class="icon-btn"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  position: relative;
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-house-door"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354l-6-6zM2.5 14.5v-6.579l5.5-5.5 5.5 5.5v6.579h-3.5v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4h-3.5z"
                  />
                </svg>
                <!-- نمایشگر تایمر روی خانه -->
                
              </div>
            </router-link>

            <img src="/assets/media/line.png" class="divider" />

            <div class="icon-btn timer-icon-btn" :title="'مدت زمان اعتبار نشست فعال: ' + formattedTime">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-clock"
                viewBox="0 0 16 16"
              >
                <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/>
              </svg>
            </div>
 <img src="/assets/media/line.png" class="divider" />
            <img
              title="اعلان ها"
              src="/assets/media/bell.png"
              class="icon-btn"
              style="cursor: no-drop"
            />

            <img src="/assets/media/line.png" class="divider" />
           
      <router-link to="/ticket" title="پشتیبانی">
  <div
    class="icon-btn"
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
    "
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-headset" viewBox="0 0 16 16">
  <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12V6a5 5 0 0 0-5-5z"/>
</svg>
  </div>
</router-link>
            <img src="/assets/media/line.png" class="divider" />
            <router-link to="/settings">
              <img
                title="تنظیمات"
                src="/assets/media/gear.png"
                class="icon-btn"
              />
            </router-link>

            <img src="/assets/media/line.png" class="divider" />
            <!-- جایگزین دکمه خروج قدیمی کن -->
<img
  title="خروج"
  @click="confirmLogout"
  src="/assets/media/box-arrow-right.png"
  class="icon-btn"
  style="cursor: pointer"
/>
          </div>
        </div>
      </div>
    </header>
    <!-- پنل اصلی شامل سایدبار -->
    <div class="main-panel">
      <div class="sidebar-wrapper">
        <!-- کارت پروفایل (ثابت) -->
        <div class="profile-card">
          <div v-if="fullname" class="profile-header" @click.prevent="update_profile = true">
            <div class="avatar-container">
              <img
                v-if="avatarUrl"
                :src="avatarUrl"
                class="avatar-img"
              />
              <img
                v-else
                src="/assets/media/blank-person.png"
                class="avatar-img-person"
              />
            </div>
            <div class="profile-info">
              <h2 class="user-name">{{ fullname }}</h2>

              <div class="company-name">
                <div
                  style="
                    background-color: rgba(73, 157, 243, 0.1);
                    color: var(--color-primary, #499df3) !important;
                    padding: 0.5vw 0.7vw;
                    border-radius: 0.8vw;
                    font-size: 0.7vw;
                    width: 14vw;
                    display: flex;
                    flex-direction: column;
                    gap: 0.5vw;
                    align-items: center;
                    font-family: 'dana-semibold';
                  "
                  v-if="working_group_position || organizationPost"
                  class="user-role"
                >
                  <span
                    v-if="organizationPost"
                    style="
                      font-size: 0.8vw !important;
                      font-family: 'Shabnam';
                      color: rgb(189 231 247);
                    "
                    >{{ organizationPost.name }} </span
                  ><span
                    v-if="working_group_position"
                    style="
                      font-size: 0.8vw !important;
                      font-family: 'Shabnam';
                      color:rgb(207 207 207);
                    "
                    >{{ working_group_position }} بهره وری
                  </span>
                </div>
                <p
                  style="margin-top: 0.5vw; font-family: 'dana-semibold'"
                  v-if="!$cookies.isKey('mother_mode') && !company"
                >
                  {{ company_name }}
                </p>
                <p
                  style="margin-top: 0.5vw; font-family: 'dana-semibold'"
                  v-else
                >
                  {{ company }}
                </p>
              </div>
            </div>
          </div>

          <div v-else>
<span  class="loader"></span>
          </div>

          
        </div>
        <!-- منوی جدید (قابل اسکرول) -->
        <div class="new-menu-container">
          <div  v-if="fullname">
            <div
            v-for="(menuItem, index) in menuItems"
            :key="index"
            class="menu-group"
            :class="{ 'bg-[#DEE4EE80]': openSections[menuItem.id] }"
          >
            <!-- هدر منوی اصلی -->
            <div
              @click="handleMenuClick(menuItem)"
              class="menu-main-btn"
              :class="{ 'active-menu': openSections[menuItem.id] }"
            >
              <div class="menu-content">
                <img
                  :src="
                    getIcon(menuItem.id, menuItem.icon, menuItem.iconActive)
                  "
                  class="menu-icon"
                />
                <span
                  class="menu-title"
                  :class="{ 'text-primary': openSections[menuItem.id] }"
                  >{{ menuItem.title }}</span
                >
              </div>
              <i
                v-if="menuItem.alert && menuItem.alert()"
                class="custom-marker-dot bg-danger"
              ></i>
              <!-- تغییر: اضافه شدن کلاس arrow-icon و منطق چرخش -->
              <svg
                v-if="menuItem.children"
                class="arrow-icon"
                :class="{ 'rotate-down': openSections[menuItem.id] }"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                />
              </svg>
            </div>
            <!-- بدنه منو (زیرمنوها) -->
            <transition
              name="accordion"
              @enter="startTransition"
              @after-enter="endTransition"
              @leave="startTransition"
              @after-leave="endTransition"
            >
              <div
                v-show="openSections[menuItem.id] && menuItem.children"
                class="submenu-wrapper"
              >
                <div class="submenu-list">
                  <!-- شروع تغییرات در Template -->
                  <div
                    v-for="(subItem, subIndex) in menuItem.children"
                    :key="subIndex"
                    class="submenu-item group"
                  >
                    <!-- اگر زیرمنو فرزند داشت (سطح ۳) -->
                    <template v-if="subItem.children">
                      <div
                        @click="toggleSubSection(subItem.id)"
                        class="submenu-btn"
                        :class="{
                          'active-submenu':
                            openSubSections[subItem.id] ||
                            isActiveSubmenu(subItem),
                        }"
                      >
                        <div class="submenu-content">
                          <img
                            :src="
                              getSubIcon(
                                subItem.id,
                                subItem.icon,
                                subItem.iconActive,
                              )
                            "
                            class="sub-icon"
                          />
                          <span class="submenu-title">{{ subItem.title }}</span>
                        </div>
                        <i
                          v-if="subItem.alert && subItem.alert()"
                          class="custom-marker-dot bg-danger"
                        ></i>
                        <svg
                          class="arrow-icon sub-arrow"
                          :class="{
                            'rotate-down': openSubSections[subItem.id],
                          }"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                          />
                        </svg>
                      </div>
                      <!-- سطح ۴ (نمایش فرزندان سطح ۳) -->
                      <transition
                        name="accordion"
                        @enter="startTransition"
                        @after-enter="endTransition"
                        @leave="startTransition"
                        @after-leave="endTransition"
                      >
                        <div
                          v-show="openSubSections[subItem.id]"
                          class="nested-submenu"
                        >
                          <div class="nested-list">
                            <template
                              v-for="(
                                childItem, childIndex
                              ) in subItem.children"
                              :key="childIndex"
                            >
                              <!-- اگر سطح ۴ هم فرزند داشت (سطح ۵ - اختیاری) -->
                              <template v-if="childItem.children">
                                <div
                                  @click="toggleThirdLevel(childItem.id)"
                                  class="nested-link"
                                  :class="{
                                    'text-[#499DF3]':
                                      openThirdLevel[childItem.id],
                                  }"
                                >
                                  <span>{{ childItem.title }}</span>
                                  <i
                                    v-if="childItem.alert && childItem.alert()"
                                    class="custom-marker-dot bg-danger"
                                  ></i>
                                  <svg
                                    v-if="childItem.children"
                                    class="arrow-icon sub-arrow"
                                    :class="{
                                      'rotate-down':
                                        openThirdLevel[childItem.id],
                                    }"
                                    viewBox="0 0 16 16"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                    />
                                  </svg>
                                </div>
                                <transition name="accordion">
                                  <div
                                    v-show="openThirdLevel[childItem.id]"
                                    class="deep-nested-list"
                                  >
                                    <router-link
                                      v-for="(
                                        deepChild, deepIndex
                                      ) in childItem.children"
                                      :key="deepIndex"
                                      :to="deepChild.route"
                                      class="deep-link"
                                      :class="{
                                        'text-[#499DF3]': isActiveRoute(
                                          deepChild.route,
                                        ),
                                      }"
                                    >
                                      <span>{{ deepChild.title }}</span>
                                    </router-link>
                                  </div>
                                </transition>
                              </template>
                              <!-- اگر سطح ۴ لینک مستقیم بود -->
                              <router-link
                                v-else-if="childItem.route"
                                :to="childItem.route"
                                class="nested-link"
                                :class="{
                                  'text-[#499DF3]': isActiveRoute(
                                    childItem.route,
                                  ),
                                }"
                              >
                                <span>{{ childItem.title }}</span>
                                <i
                                  v-if="childItem.alert && childItem.alert()"
                                  class="custom-marker-dot bg-danger"
                                ></i>
                              </router-link>

                              <span v-else class="nested-link disabled-link">
                                {{ childItem.title }}
                              </span>
                            </template>
                          </div>
                        </div>
                      </transition>
                    </template>

                    <!-- اگر زیرمنو فرزند نداشت (لینک ساده سطح ۲) -->
                    <template v-else-if="subItem.route">
                      <div
                        @click="handleSubItemClick(subItem.route, menuItem.id)"
                        class="submenu-link"
                        :class="{
                          'active-submenu': isActiveRoute(subItem.route),
                        }"
                      >
                        <div class="submenu-content">
                          <img
                            :src="
                              getSubIcon(
                                subItem.id,
                                subItem.icon,
                                subItem.iconActive,
                              )
                            "
                            class="sub-icon"
                          />
                          <span class="submenu-title">{{ subItem.title }}</span>
                        </div>
                        <i
                          v-if="subItem.alert && subItem.alert()"
                          class="custom-marker-dot bg-danger"
                        ></i>
                      </div>
                    </template>

                    <template v-else>
                      <div class="submenu-link disabled-link">
                        <div class="submenu-content">
                          <span class="submenu-title">{{ subItem.title }}</span>
                        </div>
                      </div>
                    </template>
                  </div>
                  <!-- پایان تغییرات Template -->
                </div>
              </div>
            </transition>
          </div>
          </div>
          
        </div>
        <div style="background: rgb(12, 57, 123);
    margin-bottom: -1vw;
    position: sticky;
    bottom: 0.6vw;
    border-top: solid 2px #c9d4e5;
    margin-right: 0.8vw;
    margin-left: 0.8vw;border-radius: 0px 0px 10px 10px;
">
            <span style="color: white;font-size: 0.7vw !important; direction: ltr;">@ {{ dateToday }}</span>
          </div>
      </div>
    </div>
    <!-- مودال اعلان -->
    <div v-if="bell_status" class="notification-modal">
      <div class="notif-header">
        <p>اعلان ها</p>
        <p @click="bell_status = false">❌</p>
      </div>
      <div v-if="bell_items.length">
        <!-- آیتم‌های اعلان -->
      </div>
      <div v-else class="notif-empty">
        <div class="bg-white p-3 rounded">هیچ اعلانی وجود ندارد</div>
      </div>
    </div>


    <!-- مودال ویرایش پروفایل -->
          <div v-if="update_profile" class="modal-overlay">
            <div class="modal-box">
              <div class="modal-header">
                <p>تصویر پروفایل</p>
                <p @click="update_profile = false">❌</p>
              </div>
              <div class="modal-body">
                <p>لطفا تصویر پروفایل را با فرمت های PNG,JPG,JPEG درج نمایید</p>
                <!-- تغییر: اضافه شدن ref برای دسترسی مستقیم -->
                <input ref="fileInput" type="file" class="form-control" style="display: block;" accept="image/png, .jpg, .jpeg"/>
                <div class="modal-buttons">
                  <button @click="update_profile = false" class="btn btn-back">
                    برگشت
                  </button>
                  <button class="btn btn-approve" @click.prevent="uploadFile">
                    تایید
                  </button>
                  <button class="btn btn-danger" @click.prevent="removeFile">
                    حذف تصویر
                  </button>
                </div>
              </div>
            </div>
          </div>

        <!-- مودال هشدار اتمام زمان نشست -->
    <div v-if="showTimerModal" class="modal-overlay-timer">
      <div class="modal-box timer-modal">
        <div class="modal-header" style="padding: 1vw">
          <img style="width: 3vw !important; margin-bottom: 0.5vw!important;"  src="/assets/media/logo3.png" alt="سامانه جامع و یکپارچه بهفام" class="logo-image">
          <p style="font-size: 0.9vw;margin:0">⚠️ عدم دسترسی به سامانه</p>
        </div>
        <div class="modal-body">
          <p style="font-size: 0.8vw;">با توجه به محدودیت زمان مجاز استفاده از سامانه</p>
           <p style="color: #ff8f00;">نشست کاربری شما منقضی شده است</p>
          <p style="font-size: 0.8vw;">برای ادامه استفاده، لطفاً مجدداً وارد سامانه شوید</p>
        </div>
        <div class="modal-buttons">
          <button class="btn btn-approve" @click="handleTimerModalConfirm">
            تایید و خروج از سیستم  
          </button>
        </div>
      </div>
    </div>

    <!-- مودال تأیید خروج -->
<div v-if="showLogoutConfirm" class="modal-overlay-logout" @click.self="showLogoutConfirm = false">
  <div class="modal-box logout-confirm-modal">
    <div class="logout-confirm-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
        <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>
      </svg>
    </div>
    <div class="modal-header" style="justify-content: center; border: none;margin: 0;padding: 0;">
      <p style="font-size: 1vw; color: #0c397b; font-family: 'dana-semibold';margin: 0;">
        تأیید خروج از سامانه
      </p>
    </div>
    <div class="modal-body" style="text-align: center; padding: 0.5vw 1vw;">
      <p style="font-size: 0.85vw; color: #555; line-height: 1.8;margin: 0;
    margin-top: 1vw;">
        آیا مطمئن هستید که می‌خواهید از سامانه خارج شوید؟
      </p>
      <p style="font-size: 0.75vw; color: #999; margin-top: 0.5vw;">
        در صورت تأیید، نشست کاربری شما به پایان خواهد رسید.
      </p>
    </div>
    <div class="modal-buttons" style="gap: 0.8vw;">
      <button
        @click="showLogoutConfirm = false"
        class="btn btn-back"
        style="flex: 1; font-size: 0.85vw; padding: 0.6vw 1vw;"
      >
        انصراف
      </button>
      <button
        @click="performLogout"
        class="btn btn-danger"
        style="flex: 1; font-size: 0.85vw; padding: 0.6vw 1vw; background-color: #dc3545;"
      >
        بله، خارج می شوم
      </button>
    </div>
  </div>
</div>


  </div>
</template>
<script setup>
import { ref, watch, onMounted, computed, inject } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useToast } from "vue-toastification";
import { useStore } from "vuex";
const store = useStore();
const route = useRoute();
const router = useRouter();
const toast = useToast();

const $cookies = inject("$cookies");

// --- State ---
// *** متغیرهای تایمر ***
const TIMER_DURATION = 2 * 60 * 60 * 1000;

const remainingTime = ref(store.state.session_end_time);
const isTimerActive = ref(false);
let timerInterval = null;

const showTimerModal = ref(false); // نمایش مودال هشدار
const dateToday=ref("");
const avatarUrl =ref("");
const openThirdLevel = ref({});
const bell_status = ref(false);
const bell_items = ref([]);
const update_profile = ref(false);
const fullname = ref("");
const organizationPost = ref("");
const working_group_position = ref("");
const company = ref("");
const company_name = ref("");
const base_url = ref("https://apibehfam-ict.ara-softco.ir/api");
const fileInput = ref(null);

// وضعیت باز و بسته بودن منوها
const openSections = ref({});
const openSubSections = ref({});

// وضعیت‌های هشدار
const alerts = ref({
  alert1: false,
  alert2: false,
  alert3: false,
  alert4: false,
  alert5: false,
  alert6: false,
  alert7: false,
  alert8: false,
  alert9: false,
});

// *** تعریف لیست کامل منوها به صورت ثابت ***
const allMenuItems = [
  {
    id: "org_structure",
    title: "مدیریت ساختار سازمانی",
    icon: "/assets/media/icon1-gray.png",
    iconActive: "/assets/media/icon1-blue.png",
    route: "/pishkhan/list/user",
    alert: () => alerts.value.alert8,
    children: [
      {
        id: "organizational_types",
        title: "تیپ سازمانی",
        route: "/pishkhan/Organization/types",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "users",
        title: "کاربران",
        route: "/pishkhan/list/user",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "units",
        title: "واحد سازمانی",
        route: "/pishkhan/Organization/units",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "posts",
        title: "پست سازمانی",
        route: "/pishkhan/Organization/list",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "business_units",
        title: "واحدهای کسب و کار",
        route: "/strategicManagement/basic_defined",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "exec_elements",
        title: "ارکان اجرایی",
        route: "/executive_elements",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
        alert: () => alerts.value.alert8,
      },
    ],
  },
  {
    id: "process_mgmt",
    title: "مدیریت فرآیندها",
    icon: "/assets/media/icon2-gray.png",
    iconActive: "/assets/media/icon2-blue.png",
    route: "/process/map",
    children: [
      {
        id: "process_map",
        title: "تعریف نقشه فرآیندی",
        route: "/process/map",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "process_id",
        title: "تعریف شناسنامه فرآیند",
        route: "/process/id",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "design_modeling",
        title: "طراحی و مدلسازی فرآیند",
        route: "/Design_and_modeling",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "process_docs",
        title: "مدیریت مستندات فرآیندی",
        route: "/Process/documentation/management",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "roles",
        title: "نقش ها و مسئولیت ها",
        route: "/RolesAndResponsibilities",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "job_eval",
        title: "کارسنجی",
        route: "/job/evaluation",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "matrix",
        title: "ماتریس ارتباطات",
        route: "/Matrix_Connections",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },

      {
        id: "systems",
        title: "سامانه ها",
        route: "/systems/list", // مسیر صفحه مربوط به سامانه‌ها را اینجا تنظیم کنید
        icon: "/assets/media/caret-left.png", // اگر آیکن خاصی دارید آدرس آن را بگذارید
        iconActive: "/assets/media/caret-left.png",
      },
    ],
  },
  {
    id: "stakeholders",
    title: "مدیریت ذی نفعان",
    icon: "/assets/media/icon3-gray.png",
    iconActive: "/assets/media/icon3-blue.png",
    route: "/beneficiary/map",
    children: [
      {
        id: "stake_map",
        title: "نقشه ذی نفعان",
        route: "/beneficiary/map",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "stake_id",
        title: "شناسایی نیازهای ذی نفعان",
        route: "/beneficiary/id",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "stake_eval",
        title: "ارزیابی ذی نفعان",
        route: "/beneficiary/order_by",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "stake_analytics",
        title: "ارزیابی نیازها و انتظارات",
        route: "/beneficiary_analytics",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
    ],
  },
  {
    id: "strategic",
    title: "مدیریت استراتژیک",
    icon: "/assets/media/icon4-gray.png",
    iconActive: "/assets/media/icon4-blue.png",
    route: "/Strategic_readiness_assessment",
    children: [
      {
        id: "strat_ready",
        title: "ارزیابی آمادگی استراتژیک",
        route: "/Strategic_readiness_assessment",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "strat_plan",
        title: "برنامه ریزی استراتژیک",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
        children: [
          {
            id: "vision",
            title: "تدوین ارکان جهت ساز",
            route: "/Vision_working_group",
            icon: "/assets/media/caret-left.png",
            iconActive: "/assets/media/caret-left.png",
          },
          {
            id: "env_external",
            title: "تحلیل محیط بیرونی",
            icon: "/assets/media/caret-left.png",
            iconActive: "/assets/media/caret-left.png",
            children: [
              {
                id: "porter",
                title: "۵ نیروی پورتر",
                route: "/5_f/intro",
                icon: "/assets/media/caret-left.png",
                iconActive: "/assets/media/caret-left.png",
              },
              {
                id: "pestel",
                title: "PESTEL",
                route: "/pestel",
                icon: "/assets/media/caret-left.png",
                iconActive: "/assets/media/caret-left.png",
              },
            ],
          },
          {
            id: "env_internal",
            title: "تحلیل محیط درونی",
            icon: "/assets/media/caret-left.png",
            iconActive: "/assets/media/caret-left.png",
            children: [
              {
                id: "5m",
                title: "5M",
                route: "/5m",
                icon: "/assets/media/caret-left.png",
                iconActive: "/assets/media/caret-left.png",
              },
              {
                id: "internal_eval",
                title: "ارزیابی عوامل داخلی",
                route: "/internal_evaluation",
                icon: "/assets/media/caret-left.png",
                iconActive: "/assets/media/caret-left.png",
              },
            ],
          },
          {
            id: "strategy_formulation",
            title: "تدوین استراتژی ها",
            route: "/Develop_strategies",
            icon: "/assets/media/caret-left.png",
            iconActive: "/assets/media/caret-left.png",
          },
        ],
      },
      {
        id: "strat_current",
        title: "جاری سازی استراتژیک",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
        children: [
          {
            id: "balanced_scorecard",
            title: "کارت امتیازی متوازن",
            route: "/balanced_scorecard",
            icon: "/assets/media/caret-left.png",
            iconActive: "/assets/media/caret-left.png",
          },
          {
            id: "strategic_monitoring",
            title: "پایش استراتژیک",
            route: "/strategic_monitoring",
            icon: "/assets/media/caret-left.png",
            iconActive: "/assets/media/caret-left.png",
          },
        ],
      },
    ],
  },
  {
    id: "financial",
    title: "مالی و بهره وری",
    icon: "/assets/media/icon5-gray.png",
    iconActive: "/assets/media/icon5-blue.png",
    route:
      "/Financial_management_and_productivity/FaceDefinitionFinancialSituation",
    alert: () => alerts.value.alert1,
    children: [
      {
  id: "fin_defs",
  title: "تعاریف پایه",
  icon: "/assets/media/caret-left.png",
  iconActive: "/assets/media/caret-left.png",
  alert: () => alerts.value.alert1,
  children: [
    {
      id: "fin_face",
      title: "ساختار صورت وضعیت مالی",
      route:
        "/Financial_management_and_productivity/FaceDefinitionFinancialSituation",
    },
    {
      id: "fin_profit",
      title: "ساختار صورت سود و زیان",
      route:
        "/Financial_management_and_productivity/ProfitAndLossStructure",
    },
    {
      id: "fin_agreement",
      title: "موافقتنامه",
      route:
        "/Financial_management_and_productivity/Agreement",
    },
    {
      id: "fin_cash",
      title: "صورت جریان وجوه نقد",
      route:
        "/Financial_management_and_productivity/TheStructureOfTheCashFlowStatement",
    },
    {
      id: "fin_output",
      title: "ستانده",
      route: "/Financial_management_and_productivity/DefinitionOfOutput",
    },
    {
      id: "fin_consequence",
      title: "پیامد",
      route:
        "/Financial_management_and_productivity/DefinitionOfConsequence",
    },
    {
      id: "fin_effect",
      title: "اثر",
      route: "/Financial_management_and_productivity/DefinitionOfEffect",
    },
    {
      id: "fin_plan",
      title: "مدیریت طرح",
      route: "/Financial_management_and_productivity/plan-management",
    },
    {
      id: "fin_coeff",
      title: "ضرایف تعدیل",
      route:
        "/Financial_management_and_productivity/define-adjustment-coefficients",
    },
    {
      id: "fin_rep",
      title: "نماگر (شاخص)",
      route:
        "/Financial_management_and_productivity/define-productivity-representations",
    },
    {
      id: "fin_mission",
      title: "تعیین ماموریت",
      route:
        "/Financial_management_and_productivity/Determining_the_mission",
      alert: () => alerts.value.alert1,
    },
    {
      id: "fin_materials",
      title: "مواد",
      route:
        "/Financial_management_and_productivity/materials-definition",
    },
    {
      id: "fin_products",
      title: "محصولات",
      route: "/Financial_management_and_productivity/products-definition",
    },
    {
      id: "fin_energy",
      title: "انرژی",
      route: "/Financial_management_and_productivity/energy-definition",
    },
    {
      id: "fin_data",
      title: "مرکز داده",
      route: "/Financial_management_and_productivity/data-center",
    },
  ],
},
      {
        id: "fin_func",
        title: "درج اطلاعات عملکردی",
        route: "/Financial_management_and_productivity/functional_information",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "fin_budget",
        title: "درج اطلاعات بودجه ای",
        route: "/Financial_management_and_productivity/budget_information",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
    ],
  },
  {
    id: "problem_analysis",
    title: "مسئله شناسی",
    icon: "/assets/media/icon6-gray.png",
    iconActive: "/assets/media/icon6-blue.png",
    route: "/problem_analysis/Problem_identification",
    alert: () =>
      alerts.value.alert2 ||
      alerts.value.alert3 ||
      alerts.value.alert4 ||
      alerts.value.alert5 ||
      alerts.value.alert6,
    children: [
      {
        id: "prob_id",
        title: "شناسایی مسئله",
        route: "/problem_analysis/Problem_identification",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
        alert: () => alerts.value.alert2,
      },
      {
        id: "prob_prior",
        title: "اولویت بندی مسائل",
        route: "/problem_analysis/Prioritizing_issue",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
        alert: () => alerts.value.alert3,
      },
      {
        id: "prob_root",
        title: "ریشه علل مسائل",
        route: "/problem_analysis/The_root_causes_of_the_problem",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
        alert: () => alerts.value.alert4,
      },
      {
        id: "prob_basic",
        title: "تعریف اقدامات اساسی",
        route: "/problem_analysis/Definition_of_basic_measures",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
        alert: () => alerts.value.alert5 || alerts.value.alert6,
      },
    ],
  },
  {
    id: "performance",
    title: "مدیریت عملکرد",
    icon: "/assets/media/icon7-gray.png",
    iconActive: "/assets/media/icon7-blue.png",
    route: "/problem_analysis/device_monitoring_and_care",
    alert: () => alerts.value.alert7 || alerts.value.alert9,
    children: [
      {
        id: "perf_monitor",
        title: "پایش و مراقبت بهره وری",
        route: "/problem_analysis/device_monitoring_and_care",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
        alert: () => alerts.value.alert7,
      },
      {
        id: "perf_dashboard",
        title: "داشبورد عملکرد",
        route: "/performance/dashboard",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "perf_impact",
        title: "سنجش اثرات",
        route: "/Impact_Assessment",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
        alert: () => alerts.value.alert9,
      },
    ],
  },
  {
    id: "risk_management",
    title: "مدیریت ریسک",
    icon: "/assets/media/icon4-gray.png",
    iconActive: "/assets/media/icon4-blue.png",
    route: "/risk-management/risk-planning",
    children: [
      {
        id: "risk_programming",
        title: "برنامه ریزی ریسک",
        route: "/risk-management/risk-planning",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "risk_ident",
        title: "شناسایی ریسک",
        route: "",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "risk_assess",
        title: "ارزیابی ریسک",
        route: "",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
      {
        id: "risk_response",
        title: "پاسخ به ریسک",
        route: "",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
    ],
  },
  {
    id: "meeting_mgmt",
    title: "مدیریت جلسات",
    icon: "/assets/media/icon7-gray.png",
    iconActive: "/assets/media/icon7-blue.png",
    route: "/sessions/list",
    alert: () => false,
    children: [
      {
        id: "meeting_list",
        title: "لیست جلسات",
        route: "/sessions/list",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
    ],
  },
  {
    id: "system_reports",
    title: "گزارشات سیستم",
    icon: "/assets/media/icon8-gray.png",
    iconActive: "/assets/media/icon8-blue.png",
    route: "/User_activity_reports",
    children: [
      {
        id: "list_logs",
        title: "فعالیت کاربران",
        route: "/User_activity_reports",
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },

      {
        id: "processes_reports", // یک شناسه منحصر به فرد برای زیرمنوی جدید
        title: "فرآیندها",       // عنوان نمایش داده شده در منو
        route: "/reports/processes", // آدرس صفحه مربوطه (اگر ندارید، فعلا این آدرس را بگذارید یا خالی کنید)
        icon: "/assets/media/caret-left.png",
        iconActive: "/assets/media/caret-left.png",
      },
    ],
  },
];

// اضافه کن به بخش State ها (کنار بقیه ref ها)
const showLogoutConfirm = ref(false);

// --- توابع جدید ---
// نمایش مودال تأیید خروج
const confirmLogout = () => {
  showLogoutConfirm.value = true;
};

// انجام عملیات خروج (پس از تأیید کاربر)
const performLogout = async () => {
  showLogoutConfirm.value = false;
  await logout("user");
};




// *** محاسبه نقش کاربر برای نمایش منو ***
const userRole = computed(() => {
  // فرض بر این است که organizationPost یک آبجکت است و فیلد type دارد
  // اگر organizationPost رشته است، باید منطق را کمی تغییر دهید
  if (organizationPost.value && typeof organizationPost.value === 'object') {
    return organizationPost.value.type;
  }
  return null;
});

// *** محاسبه منوهای نهایی بر اساس نقش کاربر ***
const menuItems = computed(() => {
  const isProducer = userRole.value === "تهیه کننده";
  
  // کپی عمیق از منوها برای جلوگیری از تغییر در داده‌های اصلی
  let items = JSON.parse(JSON.stringify(allMenuItems));

  // فیلتر کردن منوها
  items = items.filter((item) => {
    if (isProducer) {
      return (
        item.id === "process_mgmt" || 
        item.id === "stakeholders"
      );
    }
    return true;
  });

  // اعمال تغییرات دینامیک (مثل تغییر متن منوی کاربران برای مادر)
  // این بخش را از تابع setMenuItems قبلی استخراج کرده‌ایم
  const isMother =
    store.state.is_mother == 1;

  items = items.map((item) => {
    if (item.id === "org_structure") {
      return {
        ...item,
        children: item.children
          .map((child) => {
            if (child.id === "users") {
              return {
                ...child,
                title: isMother ? "سازمان تابعه" : "کاربران",
              };
            }
            return child;
          })
          .filter((child) => {
            if (child.id === "organizational_types" && !isMother) {
              return false;
            }
            return true;
          }),
      };
    }
    return item;
  }).filter((item) => {
    if (item.id === "system_reports" && !isMother) {
      return false;
    }
    return true;
  });

  return items;
});



// --- Methods ---
const clearBrowserCache = async () => {
  try {
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        await registration.unregister();
      }
    }
    if ("caches" in window) {
      const names = await caches.keys();
      for (const name of names) {
        await caches.delete(name);
      }
    }
    window.location.reload();
    return true;
  } catch (error) {
    console.error("خطا در پاک کردن کش:", error);
    return false;
  }
};

 const toJalaali = (gy, gm, gd) => {
      var g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
      var jy = (gy <= 1600) ? 0 : 979;
      gy -= (gy <= 1600) ? 621 : 1600;
      var gy2 = (gm > 2) ? (gy + 1) : gy;
      var days = (365 * gy) + (parseInt((gy2 + 3) / 4)) - (parseInt((gy2 + 99) / 100)) + (parseInt((gy2 + 399) / 400)) - 80 + gd + g_d_m[gm - 1];
      jy += 33 * (parseInt(days / 12053));
      days %= 12053;
      jy += 4 * (parseInt(days / 1461));
      days %= 1461;
      if (days > 365) {
        jy += parseInt((days - 1) / 365);
        days = (days - 1) % 365;
      }
      var jm = (days < 186) ? 1 + parseInt(days / 31) : 7 + parseInt((days - 186) / 30);
      var jd = 1 + ((days < 186) ? (days % 31) : ((days - 186) % 30));
      return { jy: jy, jm: jm, jd: jd };
    }
const setTodayDate= () => {
      const today = new Date();
      const jalaali = toJalaali(today.getFullYear(), today.getMonth() + 1, today.getDate());
      const year = jalaali.jy;
      const month = String(jalaali.jm).padStart(2, '0');
      const day = String(jalaali.jd).padStart(2, '0');
      dateToday.value = `${year}/${month}/${day}`;
      
    }
const clearAllCookies = () => {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
  }
};

const closeSiblings = (currentId, containerRef) => {
  Object.keys(containerRef.value).forEach((key) => {
    if (key !== currentId) {
      containerRef.value[key] = false;
    }
  });
};

const toggleThirdLevel = (thirdLevelId) => {
  closeSiblings(thirdLevelId, openThirdLevel);
  openThirdLevel.value[thirdLevelId] = !openThirdLevel.value[thirdLevelId];
};

const handleMenuClick = (menuItem) => {
  if (menuItem.children) {
    const isOpen = openSections.value[menuItem.id];
    Object.keys(openSections.value).forEach((key) => {
      openSections.value[key] = false;
    });
    Object.keys(openSubSections.value).forEach((key) => {
      openSubSections.value[key] = false;
    });
    Object.keys(openThirdLevel.value).forEach((key) => {
      openThirdLevel.value[key] = false;
    });
    if (!isOpen) {
      openSections.value[menuItem.id] = true;
    }
  } else if (menuItem.route) {
    router.push(menuItem.route);
  }
};

const handleSubItemClick = (subRoute, parentId) => {
  if (subRoute) {
    router.push(subRoute);
  }
};

const initializeMenuStates = () => {
  // توجه: حالا menuItems یک computed است، بنابراین برای اینتراکشن‌های داخلی 
  // بهتر است از allMenuItems یا منطق داخلی استفاده کنیم، اما برای سادگی 
  // فعلا state را بر اساس ایندکس‌ها مدیریت می‌کنیم.
  // اگر منوها داینامیک شوند، ممکن است ایندکس‌ها تغییر کنند.
  // اما چون ما کل آرایه را فیلتر می‌کنیم، بهتر است state را بر اساس ID مدیریت کنیم که قبلا هم اینطور بود.
  // این تابع دیگر نیازی به فراخوانی مستقیم با menuItems.value ندارد مگر برای بازنشانی کامل.
  // بهتر است در setActiveMenus استفاده شود.
};

const isActiveRoute = (menuRoute) => {
  if (!menuRoute) return false;
  if (typeof menuRoute === "string") {
    const currentPath = route.path.split("?")[0];
    const pattern = new RegExp(`^${menuRoute}(/|$)`);
    return pattern.test(currentPath);
  }
  if (typeof menuRoute === "object" && menuRoute.name) {
    return route.name?.startsWith(menuRoute.name);
  }
  return false;
};



const isActiveSubmenu = (subItem) => {
  if (isActiveRoute(subItem.route)) return true;
  if (subItem.children) {
    return subItem.children.some((child) => isActiveRoute(child.route));
  }
  return false;
};

const isActiveMenu = (menuId) => {
  // جستجو در allMenuItems چون menuItems فیلتر شده است
  const menu = allMenuItems.find((item) => item.id === menuId);
  if (!menu) return false;
  if (isActiveRoute(menu.route)) return true;
  if (menu.children) {
    return menu.children.some((subItem) => {
      if (isActiveRoute(subItem.route)) return true;
      if (subItem.children) {
        return subItem.children.some((child) => isActiveRoute(child.route));
      }
      return false;
    });
  }
  return false;
};

const setActiveMenus = () => {
  // ریست کردن وضعیت‌ها
  Object.keys(openThirdLevel.value).forEach(
    (key) => (openThirdLevel.value[key] = false),
  );
  
  // پیدا کردن منوی فعال در allMenuItems برای باز کردن صحیح سایدبار
  allMenuItems.forEach((item) => {
    let shouldOpen = false;
    if (isActiveRoute(item.route)) shouldOpen = true;
    if (item.children) {
      item.children.forEach((subItem) => {
        if (isActiveRoute(subItem.route)) shouldOpen = true;
        if (subItem.children) {
          const hasActiveChildInSub = subItem.children.some((childItem) => {
            if (isActiveRoute(childItem.route)) return true;
            if (childItem.children) {
              return childItem.children.some((deepChild) =>
                isActiveRoute(deepChild.route),
              );
            }
            return false;
          });
          if (hasActiveChildInSub) {
            shouldOpen = true;
            openSubSections.value[subItem.id] = true;
            subItem.children.forEach((childItem) => {
              if (childItem.children) {
                const hasDeepActive = childItem.children.some((d) =>
                  isActiveRoute(d.route),
                );
                if (hasDeepActive) {
                  openThirdLevel.value[childItem.id] = true;
                }
              } else if (isActiveRoute(childItem.route)) {
                openThirdLevel.value[childItem.id] = true;
              }
            });
          }
        }
      });
    }
    if (shouldOpen) {
      openSections.value[item.id] = true;
    }
  });
};

const startTransition = (el) => {
  el.style.height = el.scrollHeight + "px";
  el.style.overflow = "hidden";
};

const endTransition = (el) => {
  el.style.height = "";
  el.style.overflow = "";
};

const toggleSection = (sectionId) => {
  openSections.value[sectionId] = !openSections.value[sectionId];
};

const toggleSubSection = (subsectionId) => {
  closeSiblings(subsectionId, openSubSections);
  openSubSections.value[subsectionId] = !openSubSections.value[subsectionId];
};

const findMenuById = (menuList, id) => {
  for (const item of menuList) {
    if (item.id === id) return item;
    if (item.children) {
      const found = findMenuById(item.children, id);
      if (found) return found;
    }
  }
  return null;
};

const getIcon = (id, defaultIcon, activeIcon) => {
  return openSections.value[id] || isActiveMenu(id) ? activeIcon : defaultIcon;
};

const getSubIcon = (id, defaultIcon, activeIcon) => {
  const menu = findMenuById(allMenuItems, id); // استفاده از allMenuItems برای جستجو
  if (!menu) return defaultIcon;
  if (isActiveRoute(menu.route)) {
    return activeIcon || defaultIcon;
  }
  if (menu.children) {
    const anyChildActive = menu.children.some((child) =>
      isActiveRoute(child.route),
    );
    return anyChildActive ? activeIcon || defaultIcon : defaultIcon;
  }
  return defaultIcon;
};

const uploadFile = () => {
  if (!fileInput.value || !fileInput.value.files || !fileInput.value.files[0]) {
    toast.error("فایل عکس اجباری است!");
    return;
  }
  
  
  
  var formdata = new FormData();
  formdata.append("file", fileInput.value.files[0]);
  var requestOptions = {
    credentials: 'include',
          headers: {
          
          'Accept': 'application/json',
        },method: "POST",
    
    body: formdata,
    redirect: "follow",
  };
  fetch(`${base_url.value}/user/update_image`, requestOptions)
    .then((response) => response.json())
    .then((response) => {
       if (response.error) {
        toast.error(response.error);
              }

      if (response.message) {
        toast.success(response.message);
        
        window.location.reload();
        
      }
    })
    .catch();
};

const removeFile = () => {
 
  
  
  var formdata = new FormData();
  formdata.append("remove", "");
  var requestOptions = {
    credentials: 'include',
          headers: {
          
          'Accept': 'application/json',
        },method: "POST",
    
    body: formdata,
    redirect: "follow",
  };
  fetch(`${base_url.value}/user/update_image`, requestOptions)
    .then((response) => response.json())
    .then((response) => {
      if (response.message) {
        toast.success(response.message);
        
        window.location.reload();
        
      }
    })
    .catch();
};

// فرمت کردن زمان به صورت HH:MM:SS
const formatTime = (ms) => {
  if (ms <= 0) return "00:00:00";
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

// محاسبه‌گر برای تمپلیت
const formattedTime = computed(() => formatTime(remainingTime.value));

// شروع تایمر
const startSessionTimer = () => {
  // تلاش برای خواندن زمان از حافظه نشست (Session)
  let endTime = store.state.session_end_time;
  
  // اگر زمانی ذخیره نشده بود، یا زمانی که ذخیره شده منقضی شده بود (بیشتر از ۳ ساعت)،
  // یک زمان جدید برای این نشست ایجاد کن
  if (endTime <= 1000) {
   logout("user")
    
  } else{
    timerInterval = setInterval(updateTimer, 1000);
    isTimerActive.value = true;
  }
    
  }

  const updateTimer = () => {
    let timeLeft = store.state.session_end_time;
    store.commit("set_time",timeLeft-1000);
   
    if (timeLeft <= 1000) {
      logout("time")
      remainingTime.value = 0;
      isTimerActive.value = false;
   
showTimerModal.value = true; // نمایش مودال
isTimerActive.value = false;
    if (timerInterval) {
    clearInterval(timerInterval);
    timerInterval = null;
    toast.warning("مدت زمان نشست شما به پایان رسید.");
  }
      
    } else {
      remainingTime.value = timeLeft;
      isTimerActive.value = true;
    }
  

  
  
};

// توقف تایمر
const stopSessionTimer = () => {
  if (timerInterval) {
    clearInterval(timerInterval);
    timerInterval = null;
  }
  
  isTimerActive.value = false;
};



const handleTimerModalConfirm = () => {
  showTimerModal.value = false;
  logout("user"); // انجام عملیات لاگ‌اوت
};

// *** تغییر در تابع logout موجود ***
// تابع logout قبلی را با این نسخه جایگزین کنید تا هنگام خروج دستی، تایمر هم پاک شود:
const logout = async (type) => {
  showTimerModal.value = false; // بستن مودال اگر باز است
 
  stopSessionTimer(); // توقف تایمر

  try {
    

   
      await fetch(`${base_url.value}/auth/logout`, {
        method: 'POST',
        credentials: 'include',
          headers: {
          
          'Accept': 'application/json',
        },
        
        
      });
   
  } catch (error) {
    console.error('Error during logout API call:', error);
  } finally {
    store.commit("logout",type);
    showLogoutConfirm.value = false; // بستن مودال تأیید در هر صورت
  }
};

const loadAvatar = async () => {
  
  if (!store.state.image_profile) {
    
    return;
  }
  try {
    // 2. تنظیم هدرها و ارسال درخواست
    const response = await fetch(`${base_url.value}/profile_image`, {
      credentials: 'include',
          headers: {
          
          'Accept': 'application/json',
        },method: "GET",
      headers: {
        
        "Accept": "application/json"
      }
    });
    if (!response.ok) {
      throw new Error('خطا در دریافت تصویر');
    }
    // 3. تبدیل پاسخ به Blob
    const blob = await response.blob();
    // 4. ساخت URL موقت
    if (avatarUrl.value) {
      URL.revokeObjectURL(avatarUrl.value);
    }
    avatarUrl.value = URL.createObjectURL(blob);
  } catch (error) {
    console.error('خطا در بارگذاری تصویر:', error);
    // در صورت خطا، avatarUrl خالی می‌ماند و عکس پیش‌فرض نمایش داده می‌شود
  }
};

const fetchItems = async () => {
  try {
    
    
    
    const formdata = new FormData();
    const requestOptions = {
      credentials: 'include',
          headers: {
          
          'Accept': 'application/json',
        },method: "POST",
      headers: {
        'Accept': 'application/json'
    },
      body: formdata,
      redirect: "follow",
    };
    const response = await fetch(`${base_url.value}/user/show`, requestOptions);
    const result = await response.json();
    if (result.error) {
      logout("user");
      return;
    }
    if (result["item"]) {
      fullname.value = result["item"]["fullname"];
      if (result["item"]["organization_post"]) {
        organizationPost.value = result.item.organization_post;
        // اگر organization_post یک آبجکت است که type دارد، آن را نگه می‌داریم
        // اگر رشته است، باید در computed userRole منطق را تغییر دهیم
      }
      if (result["working_group_position"]) {
        working_group_position.value = result.working_group_position;
      }
      if (result["item"]["company"]) {
        company.value = result.item.company.name;
      }
      if (result["item"]["company_name"]) {
        company_name.value = result.item.company_name;
      }
      if (
        result.c1_step_1 ||
        result.c1_cancelled_p ||
        result.c1_cancelled_s ||
        result.c1_complete
      )
        alerts.value.alert1 = true;
      if (
        result.c2_step_1 ||
        result.c2_cancelled_p ||
        result.c2_cancelled_s ||
        result.c2_complete
      )
        alerts.value.alert2 = true;
      if (
        result.c3_step_1 ||
        result.c3_cancelled_p ||
        result.c3_cancelled_s ||
        result.c3_complete
      )
        alerts.value.alert3 = true;
      if (
        result.c4_step_1 ||
        result.c4_cancelled_p ||
        result.c4_cancelled_s ||
        result.c4_complete
      )
        alerts.value.alert4 = true;
      if (
        result.c5_step_1 ||
        result.c5_cancelled_p ||
        result.c5_cancelled_s ||
        result.c5_complete
      )
        alerts.value.alert5 = true;
      if (
        result.c6_step_1 ||
        result.c6_cancelled_p ||
        result.c6_cancelled_s ||
        result.c6_complete
      )
        alerts.value.alert6 = true;
      if (
        result.c7_step_1 ||
        result.c7_cancelled_p ||
        result.c7_cancelled_s ||
        result.c7_complete
      )
        alerts.value.alert7 = true;
      if (result.c8_step_1 || result.c8_cancelled_p || result.c8_cancelled_s)
        alerts.value.alert8 = true;
      if (
        result.c9_step_1 ||
        result.c9_cancelled_p ||
        result.c9_cancelled_s ||
        result.c9_complete
      )
        alerts.value.alert9 = true;
    }
  } catch (error) {
    console.error("Error fetching items:", error);
  }
};

// --- Lifecycle ---
watch(
  () => route.path,
  () => {
    setActiveMenus();
  },
  { immediate: true },
);

onMounted(() => {
  // setMenuItems دیگر نیاز نیست چون در computed menuItems انجام می‌شود
  fetchItems();
  setActiveMenus();
  startSessionTimer();
  loadAvatar();
  setTodayDate();

});

const isDisabled = computed(() => store.state.is_show);
</script>
<style scoped lang="scss">
/* استایل‌های عمومی */
.sidebar-container {
  width: 100%;
  direction: rtl;
  font-family: "yekanBakh", sans-serif;
}
/* --- استایل اسکرول بار جذاب و باریک --- */
/* کانتینر اصلی سایدبار */
.sidebar-wrapper {
  position: absolute;
  right: 0;
  top: 4.01vw;
  padding: 0;
  width: 18vw;
  height: calc(100vh - 4.01vw);
  
  display: flex;
  flex-direction: column;

  /* استایل‌دهی اسکرول بار برای مرورگرهای کروم، اج، سافاری و اج‌اج */
  &::-webkit-scrollbar {
    width: 0.2vw !important; /* باریک کردن اسکرول بار */
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1; /* رنگ پس‌زمینه ریل اسکرول */
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #0c397b !important; /* رنگ اسکرول بار (همرنگ هدر) */
    border-radius: 10px; /* گرد کردن گوشه‌های اسکرول */

    &:hover {
      background: #457ed8; /* رنگ کمی تیره‌تر هنگام هاور */
    }
  }

  /* برای فایرفاکس */
  scrollbar-width: thin;
}
/* هدر */
.custom-header {
  width: 100%;
  background-color: rgb(12 57 123);
  height: 4vw;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 5;
}
.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0.1vw;
  width: 15vw;
}
.logo-img {
  width: 10vw;
}
.header-actions {
  color: white;
  width: calc(100% - 15vw);
}
.support-text {
  font-size: 0.9vw !important;
  padding-top: 1.3vw;
  font-family: "yekanBakh", sans-serif;
  color: white;
  font-weight: 100;
}
.action-icons {
  display: flex;
  align-items: center;
  gap: 1.1vw;
}
p:not(.card-panel-sidebar p)

 {
    font-size: 0.8VW;
    text-align: center;
}
.icon-btn {
  cursor: pointer;
  height: 1.3vw;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 1.4vw;
    height: 1.3vw;
    fill: white;
    transition: fill 0.3s;
  }
  &:hover svg {
    fill: #ddd;
  }
}
.divider {
  height: 1.3vw;
  width: auto;
}
/* پنل اصلی */
.main-panel {
  margin: auto;
  margin-top: -4.5vw;
  width: 100%;
}
/* کارت پروفایل */
.profile-card {
  background:rgb(12 57 123);
  border-radius: 10px 10px 0px 0px;
  border-bottom: solid 1px rgb(219, 219, 219);
  padding: 1vw;
  flex-shrink: 0;
  position: sticky;
  top: 0;

  margin: 0.8vw;
  box-shadow: 0 0.2vw 0.8vw rgb(0 0 0 / 0%);
}
.profile-header {
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-direction: column;
}
.avatar-img {
  width: 3vw;
  height: 3vw;
  object-fit: cover;
  border-radius: 50%;
  border: solid 0.15vw rgb(222, 222, 223);
 
}

.avatar-img-person {
  width: 3vw;
  height: 3vw;
  object-fit: cover;
  border-radius: 50%;
  
}
.profile-info {
  flex-grow: 1;
  text-align: right;
}
.user-name {
  font-size: 0.9vw !important;
  margin-bottom: 0.2vw;
  color: rgb(222 222 223);
  font-weight: 600;
  line-height: 1.3vw;
  text-align: center;
  font-family: "dana-semibold";
  margin-top: 0.5vw;
}
.user-role {
  color: rgb(78, 78, 82);
  font-size: 0.7vw;
  margin: 0.2vw 0vw;
  font-weight: 100;
}
.user-org-post {
  color: rgb(153 153 153);
  font-size: 0.7vw;
  margin: 0px;
  font-weight: 100;
  font-family: "dana-semibold";
  text-align: center;
}
.company-name {
  margin-top: 0.5vw;
  text-align: right;
}
.company-name p {
  font-size: 0.8vw;
  color: #d4d4d5;
  margin: 0;
  padding: 0;
  text-align: center;
}
.label {
  font-size: 0.8vw;
  color: #b3b3b3;
}
/* مودال پروفایل */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(0 0 0 / 78%);
  z-index: 99999999;
  display: flex;
  justify-content: center;
  align-items: center;
}


.modal-overlay-timer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(6 34 74 / 97%);
  z-index: 999999999999999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-box {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 23vw;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}
.modal-buttons {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}
.btn {
  padding: 5px 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: white;
}
.btn-back {
  background-color: #6c757d;
}
.btn-approve {
  background-color: #007bff;
      font-size: 0.8vw;
}
.btn-danger {
  background-color: #dc3545;
}
/* --- استایل‌های جدید منو --- */
.new-menu-container {
  padding: 0.5vw 0vw;
  flex-grow: 1;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 0px 0px 10px 10px;
  box-shadow: 0 0.2vw 0.8vw rgb(0 0 0 / 0%);
  margin: 0.8vw;
  margin-top: -0.7vw;

  /* اعمال استایل اسکرول بار به کانتینر منو نیز */
  &::-webkit-scrollbar {
    width: 0.5vw;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #0c397b;
    border-radius: 10px;
    &:hover {
      background: #0c397b;
    }
  }
}
.menu-group {
  width: 100%;
  border-radius: 10px 0 0 10px;
  margin-bottom: 8px;
}
.menu-main-btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 2vw;
  padding-left: 0.75vw;
  padding-top: 0.75vw;
  padding-bottom: 0.75vw;
  text-align: right;
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  border-radius: 10px 0 0 10px;
  position: relative;

  /* استایل هاور */
  &:hover {
    background-color: #dee4ee;
    border-radius: 10px 0 0 10px;
  }
}
/* استایل اکتیو برای منوی اصلی (سطح اول) */
.menu-main-btn.active-menu {
  background-color: #dee4ee;
  border-radius: 10px 0 0 10px;
}
.menu-content {
  display: flex;
  align-items: center;
  gap: 1.25vw;
}
.menu-icon {
  width: 1.2vw;
  height: auto;
  transition: all 0.3s;
}
.menu-title {
  color: #474747;
  font-size: 0.9vw;
  white-space: nowrap;
}
/* استایل فلش‌ها */
.arrow-icon {
  width: 0.7vw;
  height: 0.7vw;
  transition: transform 0.3s ease;
  margin-right: 0.5vw;
  /* تغییر: حالت پیش‌فرض رو به چپ (چرخش ۹۰ درجه) */
  transform: rotate(90deg);
}
/* تغییر: حالت باز رو به پایین (چرخش ۰ درجه) */
.arrow-icon.rotate-down {
  transform: rotate(0deg);
}
/* زیرمنو */
.submenu-wrapper {
  overflow: hidden;
}
.submenu-list {
  margin-top: 0.5vw;
  padding-right: 0.5vw;
}
.submenu-item {
  margin-bottom: 4px;
}
/* استایل مشترک برای دکمه‌های زیرمنو */
.submenu-btn,
.submenu-link {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 1.75vw;
  padding-left: 1.25vw;
  padding-top: 0.5vw;
  padding-bottom: 0.5vw;
  text-align: right;
  color: #474747;
  background: transparent;
  border: none;
  border-radius: 8px 0px 0px 8px;
  transition: all 0.2s;
  text-decoration: none;
  cursor: pointer;
  position: relative;

  /* استایل هاور */
  &:hover {
    background-color: #e9f0f9;
    color: #499df3;
    transform: translateX(-4px);
  }
}
/* استایل اکتیو برای زیرمنو (سطح دوم) */
.submenu-btn.active-submenu,
.submenu-link.active-submenu {
  background-color: #e9f0f9;
  color: #499df3;
  /* اگر می‌خواهید افکت جابجایی هم داشته باشد، خط زیر را فعال کنید */
  /* transform: translateX(-4px); */
}
.disabled-link {
  cursor: not-allowed;
  opacity: 0.6;
  &:hover {
    background-color: transparent;
    color: #474747;
    transform: none;
  }
}
.submenu-content {
  display: flex;
  align-items: center;
  gap: 0.75vw;
}
.sub-icon {
  width: 0.8vw;
  height: auto;
  transition: all 0.3s;
}
.submenu-title {
  font-size: 0.85vw;
  white-space: nowrap;
}
/* زیرمنوی سطح سوم */
.nested-submenu {
  overflow: hidden;
}
.nested-list {
  margin-top: 4px;
  margin-right: 1.9vw;
  border-right: 1px solid #474747;
  background: rgb(255 255 255);
  padding: 0.7vw 0;
}
/* تغییرات استایل برای منوی سطح سوم */
.nested-link {
  display: block;
  padding: 6px 1.25vw;
  color: #474747;
  font-size: 0.8vw !important;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  text-decoration: none;
  position: relative;

  /* اضافه کردن فاصله عمودی بین آیتم‌ها */
  margin-bottom: 6px;

  /* استایل هاور مشابه سطح دوم */
  &:hover {
    background-color: #e9f0f9;
    color: #499df3;
    transform: translateX(-4px);
  }

  /* استایل اکتیو (وقتی کلاس text-[#499DF3] اضافه می‌شود) */
  &.text-\[\#499DF3\] {
    background-color: #dee4ee;
    color: #499df3;
    border-radius: unset;
  }
}
/* کلاس‌های کمکی */
.text-primary {
  color: #499df3 !important;
}
/* نقطه قرمز هشدار */
.custom-marker-dot {
  scale: 0.4;
  position: absolute;
  right: 6px;
  top: 70%;
  transform: translateY(-50%);
}
/* انیمیشن آکاردئون */
.accordion-enter-active,
.accordion-leave-active {
  transition: height 0.3s ease-in-out;
  overflow: hidden;
}
.accordion-enter-from,
.accordion-leave-to {
  height: 0 !important;
}
/* مودال اعلان */
.notification-modal {
  background-color: #f4f5f6 !important;
  z-index: 99999999;
  transform: translateX(-40vw) translateY(-14vw);
  width: 20vw;
  height: 20vw;
  position: fixed;
  border: 1px solid #ddd;
  border-radius: 8px;
}
.notif-header {
  border-bottom: 1px solid #ccc;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
}
.notif-empty {
  padding: 20px;
  text-align: center;
}
@media print {
  .sidebar-wrapper {
    display: none;
  }
}
span,
a,
li {
  font-size: 0.8vw !important;
}
/* استایل برای لایه چهارم (زیرمنوی سطح ۳) */
.deep-nested-list {
  margin-top: 4px;
  margin-right: 2.5vw; /* کمی بیشتر از سطح قبل برای نشان دادن تورفتگی */
  border-right: 1px solid #474747;
  background: rgb(255 255 255);
  padding: 0.5vw 0;
}
.deep-link {
  display: block;
  padding: 5px 1.25vw;
  color: #474747;
  font-size: 0.75vw !important; /* کمی ریزتر */
  border-radius: 8px;
  transition: all 0.2s;
  text-decoration: none;
  margin-bottom: 4px;
}
.deep-link:hover {
  background-color: #e9f0f9;
  color: #499df3;
  transform: translateX(-3px);
}
.deep-link.text-\[\#499DF3\] {
  background-color: #dee4ee;
  color: #499df3;
}

/* استایل آیکن ساعت */
.timer-icon-btn {
   /* فاصله از آیکن خانه */
  cursor: default;
}

/* استایل بج تایمر روی آیکن خانه */
.timer-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #0c397b;
  color: white;
  font-size: 0.6vw;
  padding: 2px 4px;
  border-radius: 6px;
  font-family: 'dana-semibold', monospace; /* فونت مناسب برای اعداد */
  min-width: 4.5vw;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
  z-index: 10;
  line-height: 1.2;
}

.timer-warning {
  background-color: #dc3545;
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

/* استایل اختصاصی مودال تایمر */
.timer-modal {
  width: 30vw;
  border: 2px solid #dc3545;
  box-shadow: 0 0 15px rgba(220, 53, 69, 0.5);
}

.timer-modal .modal-header {
  color: #dc3545;
    border-bottom: 1px solid #dc3545;
    justify-content: center !important;
    margin: 0 !important;
    padding: 0;
    flex-direction: column;
}

/* استایل متن مودال */
.timer-modal .modal-body p {
  margin: 10px 0;
  text-align: center;
  font-size: 0.9vw;
  color: #333;
}

/* --- لودر --- */
.loader {
width: 2vw;
    height: 2vw;
    border: 2px solid #fff;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    animation: rotation-60ef2d09 1s linear infinite;
    margin: 0;
    margin-top: 4.45vw;
    margin-bottom: 4vw;
}

@keyframes rotation {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* --- انیمیشن‌ها --- */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

/* --- استایل مودال تأیید خروج --- */
.modal-overlay-logout {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(6 34 74 / 60%);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 99999999999999;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.2s ease-out;
}

.logout-confirm-modal {
  width: 24vw;
  max-width: 400px;
  padding: 1.5vw 1.2vw;
  border-radius: 12px;
  border-top: 4px solid #dc3545;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  animation: slideUp 0.3s ease-out;
}

.logout-confirm-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 0.8vw;
  color: #ff8f00;
  
  svg {
    width: 3vw !important;
    height: 3vw !important;
  }
}

/* انیمیشن برای آیکن هشدار */
.logout-confirm-icon svg {
  animation: warningShake 0.6s ease-in-out;
}

@keyframes warningShake {
  0%, 100% { transform: rotate(0deg); }
  20% { transform: rotate(-10deg); }
  40% { transform: rotate(8deg); }
  60% { transform: rotate(-6deg); }
  80% { transform: rotate(4deg); }
}

/* دکمه‌های مودال خروج */
.logout-confirm-modal .modal-buttons {
  margin-top: 1.2vw;
  padding: 1vw;
}

.logout-confirm-modal .btn {
  font-family: 'dana-semibold';
  transition: all 0.2s ease;
}

.logout-confirm-modal .btn-back {
  background-color: #6c757d;
  
  &:hover {
    background-color: #5a6268;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(108, 117, 125, 0.3);
  }
}

.logout-confirm-modal .btn-danger {
  &:hover {
    background-color: #c82333 !important;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
  }
}

.logout-confirm-modal .btn:active {
  transform: translateY(0);
}
</style>
